import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import img10 from '../../img/vpm/10.png'
import img11 from '../../img/vpm/11.png'
import img12 from '../../img/vpm/12.png'
import img13 from '../../img/vpm/13.png'

export const VpM = () => {
    const des= {
        sam: ['mode -101H', 'Max Strap Size -Notstipulte', 'Min Strap Size 60*30','Strapping Speed - 1.5','Strap Width - 6-15' , 'Strap Force - 450','Dimension - 900*580*750/500'],
        img12:['CHAMBER - DOUBLE (SS HUD)','VOLTAGE - 440V/50Hz','PUMP POWER - 1500','SEALING POWER -1000','SEALING WIDTH - 10','SEALING LENGTH - 600','WEIGHT-240','AIR CHARGING VOLUME -40','MATERIAL FORVACUUM CASE - STAINLESS STEEL','LOWEST PRESSURE - 1','SEALING POSITION - 2','VOLUME CHAMBER BULK -720*550*45','DIMENSION - 1485*735*930'],
        img10:['Weight -40','Dimension - 400*350*350','Champer Size - 380*295*65','Voltage - 220/50-60','Sealing Size -280*2','Consume Of Voltage - 100','Motor Of Voltage - 370','Input Current - 2.6 A','Model -VP VP300'],
        img11:['Model - VP400/500/600','Chamber - Single (Fibre Top)','Voltage - 220V/50Hz',' Sealing Power - 500/750/1000','Sealing Width - 10','Sealing Length - 400/500/500','Weight - 110/125/150','Vacuum Case Material - fibre'],
        img13:['Voltage - 380V/50Hz','Sealing Power - 600/1000','Motor Power - 750',' Air Compressor - 1100','Sealing length - 600/700/800/1000','Sealing Width - 10','Weight - 255']
      }
  return (
    <div className='prdmain'>
    <div className='head2'>
      <h1>Vacuum Packing Machine</h1>
    </div>
    <div className='items1'>
      <Prodcard1
        imageSrc={img10}
        model={"VP VP300"}
        title="Vacuum Packing Machine(table top)"
        altText="img of websit"
        description={des.img10}
      />
      <Prodcard1
        imageSrc={img11}
        model={"VP400/500/600"}
        title="Vacuum Packing Machine(Single chamber)"
        altText="img of websit"
        description={des.img11}
      />
      <Prodcard1
        imageSrc={img12}
        model={"VP 400/500/600 2SB"}
        title="Vacuum Packing Machine(Double chamber)"
        altText="img of websit"
        description={des.img12}
      />
       <Prodcard1
        imageSrc={img13}
        model={"VP 600V"}
        title="Vacuum Packing Machine(Vertical Type)"
        altText="img of websit"
        description={des.img13}
      />
    </div>

  </div>
  )
}
